module.exports = __webpack_public_path__ + "img/OPEN-TANAKA.215adadd.gif";